import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useI18n } from "@/lib/i18n";

export const Footer = ({ prop }) => {
  const { t } = useI18n();
  const wa = prop?.contact?.whatsapp;
  const mail = prop?.contact?.email;
  return (
    <footer className="relative overflow-hidden bg-ink text-paper grain" data-testid="site-footer">
      <div className="mx-auto max-w-[1280px] px-5 pb-28 pt-20 sm:px-8 md:pb-12">
        <p className="font-display text-[15vw] leading-[0.85] tracking-tight text-paper/[0.08] md:text-[11vw]" aria-hidden="true">Pura vida.</p>
        <div className="mt-10 grid gap-10 md:grid-cols-3">
          <div className="space-y-4">
            <Logo light />
            <p className="max-w-xs text-sm text-[#E9DFD0]">{t("ft.tag")}</p>
          </div>
          <div className="space-y-2 text-sm text-[#E9DFD0]">
            <p>{prop?.location?.area || "Sámara, Guanacaste, Costa Rica"}</p>
            {wa && <a data-testid="footer-whatsapp" className="block hover:text-accent2" href={`https://wa.me/${wa.replace(/\D/g, "")}`} target="_blank" rel="noreferrer">WhatsApp {wa}</a>}
            {mail && <a data-testid="footer-email" className="block hover:text-accent2" href={`mailto:${mail}`}>{mail}</a>}
          </div>
          <div className="flex items-end justify-between gap-4 text-xs text-[#C9BBA6] md:flex-col md:items-end">
            <Link to="/admin" data-testid="nav-admin-portal-link" className="font-mono uppercase tracking-[0.2em] hover:text-accent2">{t("ft.admin")}</Link>
            <span>© {new Date().getFullYear()} SamaraBeachHouse.com. {t("ft.rights")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
